/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetDealAcquiredJudgmentResult200Response } from '../models';
/**
 * DealAcquiredJudgmentResultApi - axios parameter creator
 * @export
 */
export const DealAcquiredJudgmentResultApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 商談獲得判断結果取得API
         * @summary 商談獲得判断結果取得API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealAcquiredJudgmentResult: async (callResultId: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'callResultId' is not null or undefined
            assertParamExists('getDealAcquiredJudgmentResult', 'callResultId', callResultId)
            const localVarPath = `/api/user/call_results/{callResultId}/transcription/deal_acquired_judgment_result`
                .replace(`{${"callResultId"}}`, encodeURIComponent(String(callResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DealAcquiredJudgmentResultApi - functional programming interface
 * @export
 */
export const DealAcquiredJudgmentResultApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DealAcquiredJudgmentResultApiAxiosParamCreator(configuration)
    return {
        /**
         * 商談獲得判断結果取得API
         * @summary 商談獲得判断結果取得API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDealAcquiredJudgmentResult(callResultId: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDealAcquiredJudgmentResult200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDealAcquiredJudgmentResult(callResultId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DealAcquiredJudgmentResultApi - factory interface
 * @export
 */
export const DealAcquiredJudgmentResultApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DealAcquiredJudgmentResultApiFp(configuration)
    return {
        /**
         * 商談獲得判断結果取得API
         * @summary 商談獲得判断結果取得API
         * @param {number} callResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDealAcquiredJudgmentResult(callResultId: number, options?: any): AxiosPromise<GetDealAcquiredJudgmentResult200Response> {
            return localVarFp.getDealAcquiredJudgmentResult(callResultId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DealAcquiredJudgmentResultApi - interface
 * @export
 * @interface DealAcquiredJudgmentResultApi
 */
export interface DealAcquiredJudgmentResultApiInterface {
    /**
     * 商談獲得判断結果取得API
     * @summary 商談獲得判断結果取得API
     * @param {number} callResultId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealAcquiredJudgmentResultApiInterface
     */
    getDealAcquiredJudgmentResult(callResultId: number, options?: AxiosRequestConfig): AxiosPromise<GetDealAcquiredJudgmentResult200Response>;

}

/**
 * Request parameters for getDealAcquiredJudgmentResult operation in DealAcquiredJudgmentResultApi.
 * @export
 * @interface DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResultRequest
 */
export interface DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResultRequest {
    /**
     * 
     * @type {number}
     * @memberof DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResult
     */
    readonly callResultId: number
}

/**
 * DealAcquiredJudgmentResultApi - object-oriented interface
 * @export
 * @class DealAcquiredJudgmentResultApi
 * @extends {BaseAPI}
 */
export class DealAcquiredJudgmentResultApi extends BaseAPI implements DealAcquiredJudgmentResultApiInterface {
    /**
     * 商談獲得判断結果取得API
     * @summary 商談獲得判断結果取得API
     * @param {DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResultRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DealAcquiredJudgmentResultApi
     */
    public getDealAcquiredJudgmentResult(requestParameters: DealAcquiredJudgmentResultApiGetDealAcquiredJudgmentResultRequest, options?: AxiosRequestConfig) {
        return DealAcquiredJudgmentResultApiFp(this.configuration).getDealAcquiredJudgmentResult(requestParameters.callResultId, options).then((request) => request(this.axios, this.basePath));
    }
}
